import { Container } from '@/components/layout';
import { PrivacyContent } from '@/components/composed';

export function PrivacyPage() {
  return (
    <Container maxWidth="xl">
      <PrivacyContent />
    </Container>
  );
}
